import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Form, Formik, Field } from "formik";
import { VerifyStaffSchema } from "../../utils/validation";
import {
  changePassword,
  resetUser,
} from "../../redux/Actions/SingleUserActions";
import Alert from "../../utils/Alert";
import Nibss from "../../assets/assets/Nibss-Logo.png";
import ModalInput from "../../components/FormInput/ModalInput";
import { useHistory } from "react-router-dom";
import { PropTypes } from "prop-types";
import { getStorageItem } from "../../components/UserNav/getStorageItem";

const ChangePasswordStaff = ({
  changePassword,
  isChanging,
  changePasswordSuccess,
  resetUser,
}) => {
  const history = useHistory();
  const { type } = getStorageItem();

  const [state, setState] = useState({
    hide: true,
    hide2: true,
    hide3: true,
  });

  useEffect(
    () => {
      if (changePasswordSuccess) {
        Alert(
          true,
          "success",
          "Success message",
          "Password changed successfully."
        );
        document.getElementById("form").reset();
        resetUser();
        if (type === "staff") {
          history.push("/dashboard");
        }
        if (type === "company_network_manager") {
          history.push("/nip/integration");
        }
      }
    },
    // eslint-disable-next-line
    [changePasswordSuccess]
  );

  const handleClick = () => {
    setState({
      ...state,
      hide: !state.hide,
    });
  };

  const handleClick2 = () => {
    setState({
      ...state,
      hide2: !state.hide2,
    });
  };

  const handleClick3 = () => {
    setState({
      ...state,
      hide3: !state.hide3,
    });
  };

  return (
    <div className="wrapper-change">
      <div className="verification-logo">
        <img src={Nibss} alt="logo" />
      </div>
      <div className="staff-change">
        <div className="staff-change-info">
          You are required to change your default password to proceed to your
          dashboard
        </div>
        <div>
          <Formik
            initialValues={{
              oldPassword: "",
              newPassword: "",
              confirmPassword: "",
            }}
            onSubmit={(values) => {
              const payload = {
                oldPassword: values.oldPassword,
                newPassword: values.newPassword,
              };
              changePassword(payload);
            }}
            validationSchema={VerifyStaffSchema}
          >
            {({ isValid, dirty }) => {
              return (
                <Form id="form">
                  <div className="modal-form">
                    <div className="modal-input-password">
                      <span onClick={handleClick}>
                        {state.hide ? "SHOW" : "HIDE"}
                      </span>
                      <Field
                        name="oldPassword"
                        label="Old Password"
                        placeholder="Enter old password"
                        type={state.hide ? "password" : "text"}
                        component={ModalInput}
                      />
                    </div>

                    <br />
                    <div className="modal-input-password">
                      <span onClick={handleClick2}>
                        {state.hide2 ? "SHOW" : "HIDE"}
                      </span>
                      <Field
                        name="newPassword"
                        label="New Password"
                        placeholder="Enter new password"
                        type={state.hide2 ? "password" : "text"}
                        component={ModalInput}
                      />
                    </div>
                    <br />
                    <div className="modal-input-password">
                      <span onClick={handleClick3}>
                        {state.hide3 ? "SHOW" : "HIDE"}
                      </span>
                      <Field
                        name="confirmPassword"
                        label="Confirm Password"
                        placeholder="Enter new password"
                        type={state.hide3 ? "password" : "text"}
                        component={ModalInput}
                      />
                    </div>

                    <br />
                    <br />
                    <div className="form-grid-central">
                      <div className="modal-input-button">
                        <button
                          type="submit"
                          className="modal-action-button"
                          disabled={isChanging || !(isValid && dirty)}
                        >
                          CHANGE
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  changePassword: (password) => dispatch(changePassword(password)),
  resetUser: () => dispatch(resetUser()),
});

const mapStateToProps = (state) => ({
  isChanging: state.singleStaff.isChanging,
  changePasswordSuccess: state.singleStaff.changePasswordSuccess,
});

ChangePasswordStaff.propTypes = {
  showModal: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  hideModal: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  changePassword: PropTypes.func,
  isChanging: PropTypes.bool,
  changePasswordSuccess: PropTypes.bool,
  resetUser: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangePasswordStaff);
